import { showModal } from '../../components/modals';
export class ConsentFormHandler {
    displayConsentForm(originalSubmitId, formContainer) {
        this.displayGlobalConsentForm(originalSubmitId);
    }
    displayGlobalConsentForm(originalSubmitId) {
        const globalConsentPopup = document.getElementById('global-consent-modal');
        if (!globalConsentPopup) {
            return;
        }
        const corednaJsForm = globalConsentPopup.querySelector('.coredna-js-form');
        if (!corednaJsForm) {
            return;
        }
        corednaJsForm.dataset.originalSubmitId = originalSubmitId;
        corednaJsForm.querySelectorAll('.form-step').forEach((formStep, key) => formStep.classList.toggle('.js-hidden', key !== 0));
        showModal(globalConsentPopup);
    }
}
